/**
 * Forms on relationships — client mirror of api/constants/formRelationships.js
 */

export const FORM_ASSIGNMENT_SOURCE = 'form_assignment';

export const FORM_RELATIONSHIP_TYPES = Object.freeze({
  FILL_OUT: 'fill_out',
  ASSIGNMENT: 'assignment'
});

export const FORM_RELATIONSHIP_TYPE_LABELS = Object.freeze({
  [FORM_RELATIONSHIP_TYPES.FILL_OUT]: 'Fill out',
  [FORM_RELATIONSHIP_TYPES.ASSIGNMENT]: 'Assignment'
});

export const FORM_RELATIONSHIP_TYPE_HINTS = Object.freeze({
  [FORM_RELATIONSHIP_TYPES.FILL_OUT]:
    'Passive intake — form fields act like profile attributes (e.g. favorite color).',
  [FORM_RELATIONSHIP_TYPES.ASSIGNMENT]:
    'Directed work — someone assigned this form (teacher task, portfolio evidence, etc.).'
});

/** @deprecated use FORM_RELATIONSHIP_TYPES.ASSIGNMENT */
export const WORK_SAMPLE_FORM_ASSIGNMENT_TYPE = FORM_RELATIONSHIP_TYPES.ASSIGNMENT;

export function formatFormRelationshipTypeLabel(type) {
  const key = String(type || '').trim().toLowerCase().replace(/\s+/g, '_');
  if (key === FORM_RELATIONSHIP_TYPES.ASSIGNMENT || key === 'form_assignment' || key === 'work_sample_assignment') {
    return FORM_RELATIONSHIP_TYPE_LABELS[FORM_RELATIONSHIP_TYPES.ASSIGNMENT];
  }
  return FORM_RELATIONSHIP_TYPE_LABELS[FORM_RELATIONSHIP_TYPES.FILL_OUT];
}

const LEGACY_FILL_OUT_ALIASES = ['fill out form', 'fill_out_form', 'has_form'];
const LEGACY_ASSIGNMENT_ALIASES = ['form_assignment', 'work_sample_assignment', 'assigned_form'];

/** Normalize relationship_type (and legacy aliases) → fill_out | assignment | null */
export function normalizeFormRelationshipType(type) {
  const raw = String(type || '')
    .trim()
    .toLowerCase();
  if (!raw) return null;
  const underscored = raw.replace(/\s+/g, '_');
  if (
    underscored === FORM_RELATIONSHIP_TYPES.FILL_OUT ||
    LEGACY_FILL_OUT_ALIASES.includes(raw) ||
    LEGACY_FILL_OUT_ALIASES.includes(underscored)
  ) {
    return FORM_RELATIONSHIP_TYPES.FILL_OUT;
  }
  if (
    underscored === FORM_RELATIONSHIP_TYPES.ASSIGNMENT ||
    LEGACY_ASSIGNMENT_ALIASES.includes(underscored) ||
    LEGACY_ASSIGNMENT_ALIASES.includes(raw)
  ) {
    return FORM_RELATIONSHIP_TYPES.ASSIGNMENT;
  }
  return null;
}

export function isFormAssignmentRelationship(form) {
  return normalizeFormRelationshipType(form?.relationship_type) === FORM_RELATIONSHIP_TYPES.ASSIGNMENT;
}
